module.exports = __webpack_public_path__ + "static/order-6e7ab086b849a129d05257fec62379b6.png";